import { useCallback, useEffect, useState } from 'react'
import type { ChartOfAccountCategory } from '../types'
import accountCategories from '../../utils/accountCategories'

const _getChartOfAccountsCategories = async () => {
	const chartOfAccounts: ChartOfAccountCategory[] = Array.isArray(
		accountCategories,
	)
		? accountCategories
		: []

	return {
		ok: true,
		json: async () => ({ chartOfAccounts }),
	}
}

function useChartOfAccountsCategories(companyUUID: string | undefined) {
	const [chartOfAccountCategories, setChartOfAccountCategories] = useState<
		ChartOfAccountCategory[]
	>([])

	const [loading, setLoading] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const doQuery = useCallback(async () => {
		if (!companyUUID) return
		setLoading(true)
		setError(null)
		let data: ChartOfAccountCategory[] = []

		try {
			const response = await _getChartOfAccountsCategories()

			if (response && response.ok) {
				const res = await response.json()
				data = res.chartOfAccounts
			} else {
				throw new Error('Response is not ok.')
			}
		} catch (err) {
			console.error('Error fetching account categories:', err)
			setError(
				'An error occurred while fetching account categories: ' + companyUUID,
			)
		}
		setChartOfAccountCategories(data)
		setLoading(false)
	}, [companyUUID])

	useEffect(() => {
		doQuery()
	}, [doQuery])

	return {
		chartOfAccountCategories,
		loading,
		error,
		refresh: doQuery,
	}
}
export type UseChartOfAccountCategoryResult = ReturnType<
	typeof useChartOfAccountsCategories
>

export default useChartOfAccountsCategories
